export default "__VITE_ASSET__DfLu3n9L__"